import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MatInput } from '@angular/material/input';
import {TranslateService} from '@ngx-translate/core';
import *  as $ from 'jquery';
import * as backInter from 'app/auth/auth-data.model';
import { EncuestaService } from 'app/main/wizard-cgo/services/encuesta.service';
import { SheduleService } from "../../../services/shedule.service";
import { SurveyStatusService } from "app/main/pagina/tools/survey-status/survey-status.service";
import { ProgramacionService } from 'app/main/wizard-cgo/services/programacion.service';
import Swal from 'sweetalert2';
import {MatSnackBar} from '@angular/material/snack-bar';
import { zonasUTC } from 'app/main/pagina/zonasUtc';
const moment = require('moment');
const momentTz = require('moment-timezone');
import {FormControl} from '@angular/forms';
@Component({
  selector: 'modal-reco',
  templateUrl: './modal-reco.component.html',
  styleUrls: ['./modal-reco.component.scss']
})
export class ModalRecoComponent implements OnInit {

  @ViewChild('inputFecha', { read: MatInput }) input: MatInput;

  idiomaActual:string;

  fechas: any[] = [
    {icono: 'send', tipo: "lanzamiento", fecha: "", hora: "", elegida: false, cargando: true, visible: true},
    // {icono: 'filter_1', tipo: "aviso1", fecha: "", hora: "", elegida: false, cargando: true, visible: true},
    // {icono: 'filter_2', tipo: "aviso2", fecha: "", hora: "", elegida: false, cargando: true, visible: true},
    {icono: 'power_settings_new', tipo: "cierre", fecha: "", hora: "", elegida: false, cargando: true, visible: true},
  ];
  columnas: string[] = ['tipoFecha', 'fechaElegida', 'acciones'];
  origen: number;

  fechaLanza: any;

  filtroCalendario: any;

  /*filtroLanzamiento = (d: Date | null): boolean => {
    return moment(d || new Date()).format('MM/DD/YYYY') > moment().format('MM/DD/YYYY')
  };*/
  filtroLanzamiento = (d: Date | null): boolean => {
    let fechaMinima: any;
    if(this.esHoy){
      console.log("entro el primer caso");
      console.log("primer fecha::::::::",moment().format('MM/DD/YYYY'));
      console.log("segunda fecha::::::::",moment(d||new Date()).format('MM/DD/YYYY'));

      if (moment().format('YYYY') == moment(d||new Date()).format('YYYY')) {
        console.log("tomo valor 1",moment(d||new Date()).format('YYYY'));
        fechaMinima = moment(d||new Date()).format('MM/DD/YYYY') > moment().format('MM/DD/YYYY')

      }else{
      console.log("tomo valor 2",moment(d||new Date()).format('YYYY'));

        fechaMinima = moment(d||new Date()).format('MM/DD/YYYY')
      }
      console.log("fecha Minima::::::::",fechaMinima);
    }
    else{
      console.log("entro el segundo caso");
      if (moment().format('YYYY') == moment(d||new Date()).format('YYYY')) {
        console.log("tomo valor 1",moment(d||new Date()).format('YYYY'));
      fechaMinima = moment(d || new Date()).format('MM/DD/YYYY') > moment().format('MM/DD/YYYY')
    }else{
      console.log("tomo valor 2",moment(d||new Date()).format('YYYY'));
      fechaMinima = moment(d || new Date()).format('MM/DD/YYYY')

    }
    }
    return fechaMinima;
    ////ORIGINAL::::::::::::
    // if(this.esHoy){
    //   fechaMinima = moment(d || new Date()).format('MM/DD/YYYY') >= moment().format('MM/DD/YYYY')
    // }
    // else{
    //   fechaMinima = moment(d || new Date()).format('MM/DD/YYYY') > moment().format('MM/DD/YYYY')
    // }
    // return fechaMinima;
  };


  // filtroAviso1 = (d: Date | null): boolean => {
  //   // this.fechaInicialGenerica = new Date(moment(this.fechaLanza).year(), moment(this.fechaLanza).month(), 1);
  //   // const diaInicial = moment();
  //   let diaInicial: any;
  //   if(this.esHoy){
  //     diaInicial = moment();
  //   }
  //   else{
  //     diaInicial = moment().add(1,'days');
  //   }
  //   const diaFinal = moment(this.fechaLanza).subtract(1,'days');
  //   const diaActual = moment(d || new Date());
  //   return diaActual.clone().format('MM/DD/YYYY') >= diaInicial.clone().format('MM/DD/YYYY') && diaActual.isBefore(diaFinal)
  // };

  filtroAviso1 = (d: Date | null): boolean => {
    // this.fechaInicialGenerica = new Date(moment(this.fechaLanza).year(), moment(this.fechaLanza).month(), 1);
    // const diaInicial = moment();
    let fechaAviso1:any;
    let diaInicial: any;
    if(this.esHoy){
      diaInicial = moment();
  }
    else{
      diaInicial = moment().add(1,'days');
    }

    const diaFinal = moment(this.fechaLanza).subtract(0,'days');
    const diaActual = moment(d || new Date());
    // console.log("diaFinal",diaFinal);
    // console.log("diaActual",diaActual);
    // console.log("return",diaActual.clone().format('MM/DD/YYYY') >= diaInicial.clone().format('MM/DD/YYYY') && diaActual.isBefore(diaFinal));
    if (moment().format('YYYY') == moment(d||new Date()).format('YYYY')) {
      console.log("entro lo del mismo año");

      fechaAviso1= diaActual.clone().format('MM/DD/YYYY') >= diaInicial.clone().format('MM/DD/YYYY') && diaActual.isBefore(diaFinal)
    }else{
      console.log("entro lo del otrooooo añooooo");
      fechaAviso1= moment(d || new Date()).format('MM/DD/YYYY') < diaFinal.clone().format('MM/DD/YYYY')

    }

    return fechaAviso1;
  };

  // filtroAviso2 = (d: Date | null): boolean => {
  //   var moment = require('moment');
  //   const diaInicial = moment(this.fechas[1].fecha);
  //   // const diaFinal = moment(this.fechaLanza).add(21,'days');
  //   const diaFinal = moment(this.fechas[1].fecha);
  //   const diaActual = moment(d || new Date());
  //   return diaActual.isAfter(diaInicial) && diaActual.isBefore(diaFinal)
  // };
//******checar mas adelante******////
  filtroCierre = (d: Date | null): boolean => {
    let moment = require('moment');
    // let diaInicial = moment(this.fechas[1].fecha);
    let diaInicial: any;
    if(this.fechas[2].fecha != ""){
      diaInicial = moment(this.fechas[2].fecha);
    }
    else{
      if(this.fechas[1].fecha != ""){
        diaInicial = moment(this.fechas[1].fecha);
      }
      else{
        diaInicial = moment(this.fechas[0].fecha);
      }
    }
    const diaActual = moment(d || new Date());
    return diaActual.isAfter(diaInicial)
  };

  zonasUTC = zonasUTC;
  indiceZona: number;
  horaInstituto: any;
  horaInstitutoTag: any;
  esHoy: boolean;
  horaMinima: string;
  diferenciaUtc: number;
  offsetPipe: string;
  startDate = new Date(2021,11, 11);
  filtroCalendarioDefault:any
  filtroHoraHoy: any;
  //libreria moment
  city_name:any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalRecoComponent>,
    private _snackBar: MatSnackBar,
    private translateSrv: TranslateService,
    private encuestaService: EncuestaService,
    private sheduleService: SheduleService,
    private surveyServ: SurveyStatusService,
    private programacionService: ProgramacionService,
  ) {
    this.idiomaActual = this.translateSrv.currentLang;
    this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang; });
  }

  ngOnInit() {
    console.log(this.data);
    this.city_name = 'TOOLBAR.CITIES.'+''+this.data.instituto;
    //se "oculta" el cierre si es que no se permite editarlo
    if(!this.data.cierreEditable){
      this.fechas[1].visible = false;
    }
    this.indiceZona = this.zonasUTC.findIndex(item => item.instituto == this.data.instituto);
    // let moment = require('moment');
    // console.log("momentUTC:",moment.utc());
    // console.log("momentParse:",moment.parseZone());
    // console.log("momentUTCFormat:",moment.utc().format());
    // console.log("momentParseOffset:",moment.parseZone().utcOffset());
    if(this.data.tipo == "fechas"){
      this.getFechaLanzamiento();
    }
    this.horaInstituto = momentTz.tz(this.zonasUTC[this.indiceZona].zona).utc(true);
    this.horaInstitutoTag = momentTz.tz(this.zonasUTC[this.indiceZona].zona);

    this.calculoOffsetPipe();
    this.calculoHoraMinima();
    //this.getFechaLanzamiento();
  }

  calculoOffsetPipe(){
    this.diferenciaUtc = moment.parseZone(momentTz.tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
    console.log("diferenciaUtc:",this.diferenciaUtc);
    let horas = this.diferenciaUtc / 60;
    if(horas < 0){
      horas = horas * -1;
      if(horas < 10){
        this.offsetPipe = "-0" + horas + "00";
      }
      else{
        this.offsetPipe = "-" + horas + "00";
      }
    }
    else{
      if(horas < 10){
        this.offsetPipe = "+0" + horas + "00";
      }
      else{
        this.offsetPipe = "+" + horas + "00";
      }
    }
    console.log("offsetPipe:",this.offsetPipe);
  }

  calculoHoraMinima(){
    let horaMinima = this.horaInstituto.clone().add(4,'hours').format('YYYY-MM-DD');
    let horaActual = moment().format('YYYY-MM-DD');
    // console.log("horaMinima:",horaMinima," horaActual:",horaActual);
    let esHoy = moment(horaActual).isSame(horaMinima);
    this.esHoy = esHoy;
    // console.log("es aun hoy?:",esHoy);
  }
  bloquearLanzamiento:boolean=false;
  getFechaLanzamiento(){
    let datos: any = {
      productoId: localStorage.getItem('productoID')
    };
    this.programacionService.getFechasProgramacionMedir(datos).subscribe((respuesta: backInter.getFechasMedir) => {
      console.log("respGetLanza",respuesta);
      if(respuesta.success){
        this.getAvisos();
        this.fechaLanza = this.alineaFechaUTC(respuesta.fechas.fechaLanzamiento);
        // this.fechas[0].fecha = this.alineaFechaUTC(respuesta.fechas.fechaLanzamiento);
        this.fechas[0].fecha = moment(respuesta.fechas.fechaLanzamiento).utc().format();
        this.fechas[0].elegida = true;
        this.fechas[0].cargando = false;
        // this.rangoAviso1();
        // this.fechas[1].fecha = this.alineaFechaUTC(respuesta.fechas.fechaCierre);
        this.fechas[1].fecha = moment(respuesta.fechas.fechaCierre).utc().format();
        this.fechas[1].elegida = true;
        this.fechas[1].cargando = false;

        let  now = moment().format('MM/DD/YYYY');
        let fechaDeLanzamiento=moment(this.fechaLanza).format('MM/DD/YYYY');
        var timestamp1 = new Date(now).getTime();
        var timestamp2 = new Date(fechaDeLanzamiento).getTime();
        if(timestamp2>timestamp1){
          console.log("Si ve puede programar un pre lanzamiento");
          this.bloquearLanzamiento=false;
        }else{
          console.log("No se puede programar un pre lanzamiento");
          this.bloquearLanzamiento=true;
        }
      }
      else{
        this.fechas[0].cargando = false;
        // this.fechas[1].cargando = false;
        // this.fechas[2].cargando = false;
        this.fechas[1].cargando = false;
      }
    }, error => {
      //console.log(error);
    });
  }

  getAvisos(){
    this.encuestaService.getAviso().subscribe((respuesta:any) => {
      console.log("getAviso:",respuesta);
      if(respuesta.success){
        if(respuesta.aviso1){
          // this.fechas[1].fecha = this.alineaFechaUTC(respuesta.aviso1);
          // this.fechas[1].elegida = true;
          // this.rangoAviso2();
        }
        if(respuesta.aviso2){
          // this.fechas[2].fecha = this.alineaFechaUTC(respuesta.aviso2);
          // this.fechas[2].elegida = true;
        }
        // this.fechas[1].cargando = false;
        // this.fechas[2].cargando = false;
      }
      else{
        // this.fechas[1].cargando = false;
        // this.fechas[2].cargando = false;
      }
    });
  }

  alineaFechaUTC(fecha:string){
    let fechaActual = moment();
    let utcActual = moment.utc();
    let diferenciaUtc = moment.parseZone().utcOffset();
    // diferenciaUtc = diferenciaUtc * -1; //invierte los minutos de diferencia con respecto a utc 0
    let fechaTransformadaMasDifUtc = moment(fecha).add(diferenciaUtc, 'minutes');
    return fechaTransformadaMasDifUtc;
  }

  resetFecha() {
    this.input.value = '';
  }

  setOrigen(origen:string){
    this.fechas.forEach((fecha, i) => {
      if(fecha.tipo === origen){
        this.origen = i;
        switch (i) {
          case 0: this.filtroCalendario = this.filtroLanzamiento; break;
          // case 1: this.rangoAviso1(); break;
          // case 2: this.rangoAviso2(); break;
          case 1: this.rangoCierre(); break;
        }
      }
    });
  }

  setFiltroHoraHoy(hoy:boolean,diaSiguiente?:boolean){
    if(hoy){
      console.log("aplicado filtro de hora para hoy");
      // let horaActualMasCuatro = moment().add(4,'hours');
      let horaActualMasCuatro = this.horaInstituto.clone().add(4,'hours');
      if(horaActualMasCuatro.hours() > 12){
        this.filtroHoraHoy = (horaActualMasCuatro.hours()-12) + ":" + horaActualMasCuatro.minutes() + " pm";
      }
      else{
        this.filtroHoraHoy = horaActualMasCuatro.hours() + ":" + horaActualMasCuatro.minutes() + " am";
      }
    }
    else{
      if(diaSiguiente){
        console.log("aplicado filtro de hora del dia siguiente a hoy");
        if(this.esHoy){
          this.filtroHoraHoy = "00:00 am";
        }
        else{
          let horaActualMasCuatro = this.horaInstituto.clone().add(4,'hours');
          if(horaActualMasCuatro.hours() > 12){
            this.filtroHoraHoy = (horaActualMasCuatro.hours()-12) + ":" + horaActualMasCuatro.minutes() + " pm";
          }
          else{
            this.filtroHoraHoy = horaActualMasCuatro.hours() + ":" + horaActualMasCuatro.minutes() + " am";
          }
        }
      }
      else{
        console.log("aplicado filtro de hora para otro dia");
        this.filtroHoraHoy = "00:00 am";
      }
    }

    console.log("filtroHoraHoy:",this.filtroHoraHoy);
  }

  /*fechaSeleccionada(event){
    console.log("evento:",event);
    let fechaElegida = event.value;
    // let moment = require('moment');
    let fechaMoment = moment(fechaElegida).format('YYYY-MM-DD');
    let fechaAnterior = this.fechas[this.origen].fecha;

    console.log("fechaEvent:",fechaElegida);
    console.log("fechaMoment:",fechaMoment);
    console.log("origen:",this.origen);

    this.fechas[this.origen].fecha = fechaMoment;

    if(this.origen == 0){
      console.log("Registra la fecha");
      if(this.tieneAvisos()){
        Swal.fire({
          title: this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.CHANGELAUNCH'),
          icon: 'warning',
          showCancelButton: true,
reverseButtons: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
          cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
        }).then((result) => {
          if (result.value) {
            this.registraFechaLanzamiento(moment(fechaElegida).format('YYYY-MM-DD'));
          }
          else{
            this.fechas[this.origen].fecha = fechaAnterior;
          }
        });
      }
      else{
        this.registraFechaLanzamiento(moment(fechaElegida).format('YYYY-MM-DD'));
      }
    }
    else{
      $("#timepicker").click();
    }
  }*/
  fechaAnterior = "";
  fechaSeleccionada(event){
    console.log("evento:",event);
    let fechaElegida = event.value;
    // let moment = require('moment');
    let fechaMoment = moment(fechaElegida).format('YYYY-MM-DD');
    this.fechaAnterior = this.fechas[this.origen].fecha;

    console.log("fechaEvent:",fechaElegida);
    console.log("fechaMoment:",fechaMoment);
    console.log("origen:",this.origen);

    this.fechas[this.origen].fecha = fechaMoment;

    // if(moment(fechaElegida).isAfter(moment())){
    console.log("fechamoment:",fechaMoment," fechaActual:",moment().format('YYYY-MM-DD'));
    if(fechaMoment == moment().format('YYYY-MM-DD')){
      this.setFiltroHoraHoy(true);
    }
    else{
      if(fechaMoment == moment().add(1,'days').format('YYYY-MM-DD')){
        this.setFiltroHoraHoy(false,true);
      }
      else{
        this.setFiltroHoraHoy(false);
      }
    }

    setTimeout(() => {
      if(this.origen == 0){
        console.log("Registra la fecha");
        let num=1;
        if(num==0){
          Swal.fire({
            title: this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.CHANGELAUNCH'),
            icon: 'warning',
            showCancelButton: true,
reverseButtons: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
            cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
          }).then((result) => {
            if (result.value) {
              this.registraFechaLanzamiento(moment(fechaElegida).format('YYYY-MM-DD'));
            }
            else{
              this.fechas[this.origen].fecha = this.fechaAnterior;
            }
          });
        }
        else{
          this.registraFechaLanzamiento(moment(fechaMoment).format('YYYY-MM-DD'));
        }
      }
      else{
        $("#timepicker").click();
      }
    }, 200);
  }

  tieneAvisos(){
    let tieneFecha = false;
    // if(this.fechas[1].fecha != "" || this.fechas[2].fecha != ""){
    //   tieneFecha = true;
    // }
    // return tieneFecha;
  }

  registraFechaLanzamiento(fecha){
    console.log(fecha);
    let hoy = moment();
    let fechaElegida = moment(fecha);
    console.log("diferencia de dias",fechaElegida.diff(hoy,'days'));

    if(localStorage.getItem('instituto') == '1' || localStorage.getItem('instituto') == 'MX'){
      if(fechaElegida.diff(hoy,'days') < 15){
        Swal.fire({
          title: this.translateSrv.instant('SHEDULE.LESSDAYS_T'),
          text: this.translateSrv.instant('SHEDULE.LESSDAYS_I'),
          icon: 'warning',
          showCancelButton: true,
reverseButtons: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
          cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
        }).then((result) => {
          if (result.value) {
            Swal.fire({
              title: this.translateSrv.instant('SHEDULE.CONFLDATE_T'),
              text: this.translateSrv.instant('SHEDULE.CONFLDATE_I'),
              icon: 'warning',
              showCancelButton: true,
reverseButtons: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
              cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
            }).then((result) => {
              if (result.value) {
                this.guardaFechaLanzamiento(fecha);
                // $("#timepicker").click();
              }
            });
          }
        });
      }
      else{
        Swal.fire({
          title: this.translateSrv.instant('SHEDULE.CONFLDATE_T'),
          text: this.translateSrv.instant('SHEDULE.CONFLDATE_I'),
          icon: 'warning',
          showCancelButton: true,
reverseButtons: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
          cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
        }).then((result) => {
          if (result.value) {
            this.guardaFechaLanzamiento(fecha);
            // $("#timepicker").click();
          }
        });
      }
    }
    else{
      Swal.fire({
        title: this.translateSrv.instant('SHEDULE.CONFLDATE_T'),
        text: this.translateSrv.instant('SHEDULE.CONFLDATE_I'),
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
        cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
      }).then((result) => {
        if (result.value) {
          this.guardaFechaLanzamiento(fecha);
          // $("#timepicker").click();
        }
      });
    }
  }

  horaSeleccionada(event){
    console.log("horaSel:",event);
    this.fechas[this.origen].hora = event;
    this.fechas[this.origen].elegida = true;
    let hora24 = moment(event, ["h:mm A"]).format("HH:mm");
    this.fechas[this.origen].fecha = this.fechas[this.origen].fecha + " " + hora24;

    let fechaActual = moment();
    let utcActual = moment.utc();
    let diferenciaUtc = moment.parseZone().utcOffset();
    let fechaSeleccionada = moment(this.fechas[this.origen].fecha);
    let diferenciaMinutos = moment(this.fechas[this.origen].fecha).diff(fechaActual, 'seconds');
    let fechaActualTransformada = moment(fechaActual).add(diferenciaMinutos, 'seconds');
    diferenciaUtc = diferenciaUtc * -1; //invierte los minutos de diferencia con respecto a utc 0
    let fechaTransformadaMasDifUtc = moment(fechaActualTransformada).add(diferenciaUtc, 'minutes').add(1, 'minutes'); //se le añade 1 minutos porque siempre se desfasa alv -_-

    console.log("utcActual:",utcActual.format());
    console.log("fechaActual:",fechaActual.format());
    console.log("diferenciaUtc:",diferenciaUtc);
    console.log("fechaSeleccionada:",fechaSeleccionada.format());
    console.log("diferenciaMinutos:",diferenciaMinutos);
    console.log("fechaActualTransformada:",fechaActualTransformada.format());
    console.log("fechaTransformadaMasDifUtc:",fechaTransformadaMasDifUtc.format());

    let  now = moment().format('MM/DD/YYYY');
    let fechaDeLanzamiento=moment(fechaActualTransformada).format('MM/DD/YYYY');
    var timestamp1 = new Date(now).getTime();
    var timestamp2 = new Date(fechaDeLanzamiento).getTime();
    console.log("Time1 "+timestamp1);
    console.log("Time2 "+timestamp2);
    if(timestamp2>timestamp1){
      console.log("Si ve puede programar un pre lanzamiento");
      this.bloquearLanzamiento=false;
    }else{
      console.log("No se puede programar un pre lanzamiento");
      this.bloquearLanzamiento=true;
    }

    switch (this.origen) {
      case 0: this.guardaFechaLanzamiento(fechaTransformadaMasDifUtc); break;
      // case 1: case 2: this.guardaFechaAviso(fechaTransformadaMasDifUtc); break;
      case 1: this.updatefechaCierre(fechaTransformadaMasDifUtc); break;
    }

  }

  guardaFechaLanzamiento(fecha:any){
    let data={
      productoId : localStorage.getItem('productoID'),
      fechaLanzamiento: fecha
    };
    console.log("datosAGuardar:",data);
    Swal.fire({
      title: this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.SAVELAUNCHDATE'),
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });
    this.programacionService.guardaFechaProgramacionMedir(data).subscribe((respuesta: any) => {
      console.log("respGuardaLanz",respuesta);
      if(respuesta.message == '221'){
        Swal.close();
        this.openSnackBar(this.translateSrv.instant('SHEDULE.DATE_REGISTERED'),this.translateSrv.instant('ALERTS.OK'));
        this.fechaLanza = respuesta.programacion.fechaLanzamiento;
        this.fechas[0].elegida = true;
        // this.rangoAviso1();
        //borra fechas avisos
        // this.fechas[1].fecha = "";
        // this.fechas[2].fecha = "";
        // this.fechas[1].elegida = false;
        // this.fechas[2].elegida = false;
        //coloca fecha cierre
        this.fechas[1].fecha = this.alineaFechaUTC(respuesta.programacion.fechaCierre);
        this.fechas[1].elegida = true;
        this.fechas[1].cargando = false;
      }
    }, error => {
      console.log(error);
    });
  }

  // guardaFechaAviso(fecha: any){
  //   let datos:any = {};
  //   switch (this.origen) {
  //     case 1: datos.aviso1 = fecha; this.rangoAviso2(); break;
  //     case 2: datos.aviso2 = fecha; break;
  //   }
  //   Swal.fire({
  //     title: this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.SAVEAVISODATE'),
  //     allowOutsideClick: false,
  //     didOpen: () => {
  //       Swal.showLoading()
  //     }
  //   });
  //   this.encuestaService.setAviso(datos).subscribe((respuesta:any) => {
  //     console.log("setAviso:",respuesta);
  //     if(respuesta.success){
  //       Swal.close();
  //       this.openSnackBar(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.AVISOOK'),this.translateSrv.instant('ALERTS.OK'));
  //     }
  //   });
  // }

  updatefechaCierre(fecha: any){
    if(moment(this.fechaLanza).isAfter(fecha)){
      Swal.fire({
        icon: 'warning',
        title: this.translateSrv.instant('SHEDULE.WARNING_FECHA_UPDATE'),
        showCancelButton: true,
reverseButtons: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
      })
    }
    else{

      Swal.fire({
        title: this.translateSrv.instant('SHEDULE.FECHA_UPDATE_WARNING'),
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,


        confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
        cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
      }).then((result) => {
        if (result.value) {
          let datos: any = {
            productoId: localStorage.getItem('productoID'),
            empresaId: localStorage.getItem('companyID'),
            fecha: fecha
          };
          this.programacionService.updateFechaCierreUsuarioEmpresa(datos).subscribe((data: any) => {
            console.log("updateFechaCierreUsuarioEmpresa:",data);
            if(data.success) {
              Swal.fire({
                icon: 'success',
                title: this.translateSrv.instant('SHEDULE.FECHA_UPDATE'),
                showCancelButton: true,
reverseButtons: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
              });
            }
          });
        }
      });
    }
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  horaAbierta(event){
    console.log("horaAbierta:",event);
  }

  salirSinHora(event){
    console.log("salirSinHora:",event);
    if(this.fechas[this.origen].hora == ""){
      this.fechas[this.origen].fecha = "";
    }
  }

  // rangoAviso1(){
  //   this.filtroCalendario = this.filtroAviso1;
  // }
  // rangoAviso2(){
  //   this.filtroCalendario = this.filtroAviso2;
  // }
  rangoCierre(){
    this.filtroCalendario = this.filtroCierre;
  }



  salir() {
    let status = true;
    // let BreakException = {};
    // try {
    //     this.fechas.forEach( (fecha,i) => {
    //       if(i != 1 && i != 2){
    //         if(!fecha.elegida){
    //           status = false;
    //           throw BreakException;
    //         }
    //       }
    //     });
    // } catch (e) {
    //     if (e !== BreakException) throw e;
    // };
    this.dialogRef.close({
      status,
      fechaLanzamiento: this.fechaLanza,
      fechaCierre: this.fechas[1].fecha
    });
  }


}
